import { render, staticRenderFns } from "./team-setup.vue?vue&type=template&id=addcc6d2&"
import script from "./team-setup.vue?vue&type=script&lang=ts&"
export * from "./team-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports